import moment from 'moment'
licenseFormDirective.$inject = ['licenseTypes']

export default function licenseFormDirective(licenseTypes) {
  return {
    restrict: 'EA',
    scope: {
      templateLicense: '='
    },
    link: function(scope) {
      // set default start date if not specified
      scope.$watch('templateLicense', function() {
        if (
          scope.templateLicense &&
          (typeof scope.templateLicense.start_date_fmt === 'undefined' ||
            scope.templateLicense.start_date_fmt == null)
        ) {
          scope.templateLicense.start_date_fmt = moment(new Date()).format('YYYY-MM-DD')
        }
      })

      scope.licenseTypes = licenseTypes
    },
    template: require('./../../partials/_licenseForm.html')
  }
}
